export default __webpack_public_path__ + "static/media/wallet.19f3d228.svg";